var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3706 3.70368C14.3706 5.0128 13.3094 6.07405 12.0003 6.07405C10.6911 6.07405 9.62988 5.0128 9.62988 3.70368C9.62988 2.39456 10.6911 1.33331 12.0003 1.33331C13.3094 1.33331 14.3706 2.39456 14.3706 3.70368ZM14.3708 12C14.3708 13.3091 13.3095 14.3704 12.0004 14.3704C10.6913 14.3704 9.63005 13.3091 9.63005 12C9.63005 10.6909 10.6913 9.62964 12.0004 9.62964C13.3095 9.62964 14.3708 10.6909 14.3708 12ZM12.0004 22.6667C13.3095 22.6667 14.3708 21.6054 14.3708 20.2963C14.3708 18.9872 13.3095 17.9259 12.0004 17.9259C10.6913 17.9259 9.63005 18.9872 9.63005 20.2963C9.63005 21.6054 10.6913 22.6667 12.0004 22.6667Z",
    fill: "#535353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.aca04a2744524d1f31d420e3fa10986f.svg";
export { ForwardRef as ReactComponent };